import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function FAQ() {
  const {
    t
  } = useLanguage();
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="py-32 lg:py-48 bg-texture-dark text-cream" data-id="element-53" data-mp="1hdukw8kiel4z">
      <div className="max-w-[1100px] mx-auto px-8 lg:px-14" data-id="element-54" data-mp="1cft27oqzwnu1">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="mb-20 lg:mb-24" data-id="element-55" data-mp="2a1ytb1ugtcbd">
          <div className="flex items-center gap-3 text-caramel text-[10px] tracking-[0.4em] uppercase mb-10" data-id="element-56" data-mp="1v7c41s9a9vuh">
            <span className="w-10 h-px bg-caramel/40" data-id="element-57" data-mp="jpswjnoo76q4" />
            {t.faq.eyebrow}
          </div>
          <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-cream leading-[0.95] tracking-[-0.02em] font-light" data-id="element-58" data-mp="1knqgrcher7zs">
            {t.faq.title1}
            <br data-id="element-59" data-mp="1pmb8somiald5" />
            <span className="italic font-extralight" data-id="element-60" data-mp="1pkqp5u1qcmu2">{t.faq.title2}</span>
          </h2>
        </motion.div>

        <div className="border-t border-cream/15" data-id="element-61" data-mp="1arwx7959ue8i">
          {t.faq.items.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="border-b border-cream/15" data-id="element-62" data-mp="11w7ex8z4dzzc" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} className="w-full flex items-baseline justify-between gap-8 py-8 lg:py-10 text-left group" data-id="element-63" data-mp="16np83auwiw9r">
                  <div className="flex items-baseline gap-6 lg:gap-10" data-id="element-64" data-mp="wxmcd2web47q">
                    <span className="font-serif italic text-caramel text-sm" data-id="element-65" data-mp="iyczac3hkq7z">
                      0{i + 1}
                    </span>
                    <span className={`font-serif text-2xl lg:text-3xl text-cream font-light tracking-[-0.01em] transition-all duration-500 ${isOpen ? 'italic' : 'group-hover:italic'}`} data-id="element-66" data-mp="myww1ek5drtl">
                      {f.q}
                    </span>
                  </div>
                  <span className={`relative w-3 h-3 shrink-0 mt-3 transition-transform duration-500 ${isOpen ? 'rotate-45' : ''}`} data-id="element-67" data-mp="2fxvd9pjfddpr">
                    <span className="absolute top-1/2 left-0 right-0 h-px bg-cream" data-id="element-68" data-mp="38m12oplfbqvx" />
                    <span className="absolute left-1/2 top-0 bottom-0 w-px bg-cream" data-id="element-69" data-mp="33mely66dzsid" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-70" data-mp="2yma7elp1h7us">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.5,
                ease: [0.22, 1, 0.36, 1]
              }} className="overflow-hidden" data-id="element-71" data-mp="2umhu5vopadj3">
                      <p className="pb-10 pl-10 lg:pl-16 pr-10 text-cream/60 leading-[1.8] text-[15px] max-w-2xl" data-id="element-72" data-mp="ch8d5p0s19hx">
                        {f.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}